export default "__VITE_ASSET__iNCpgx_I__"